import { defineStore } from 'pinia'
import router from '../router.js'
import tooManagement from '../api/tooManagement'

const emptySiteSubscriber = {
  id: 0,
  siteId: 0,
  name: '',
  description: '',
  accessToken: '',
  emailDomain: '',
  showInternal: false,
  showRegional: false,
  showExternal: true,
  archived: false,
}

export const useSiteSubscriberStore = defineStore('siteSubscriberStore', {
  state: () => ({
    isLoading: false,
    isSaving: false,
    errors: [],
    isSavedSuccessfully: false,
    siteSubscriber: { ...emptySiteSubscriber },
  }),
  actions: {
    async load(siteSubscriberId) {
      this.isLoading = true
      try {
        if (siteSubscriberId === 'new') {
          this.siteSubscriber = {
            ...emptySiteSubscriber,
            id: 'new',
          }
        } else {
          const siteSubscriber =
            await tooManagement.getSiteSubscriber(siteSubscriberId)
          this.siteSubscriber = siteSubscriber.data
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
    async save() {
      this.isSaving = true
      this.errors = []
      this.isSavedSuccessfully = false

      try {
        const subscriberToSave = { ...this.siteSubscriber }
        subscriberToSave.siteId = this.siteSubscriber.site?.id || ''
        const saveFunction =
          this.siteSubscriber.id === 'new'
            ? tooManagement.postSiteSubscriber
            : tooManagement.putSiteSubscriber
        if (this.siteSubscriber.id === 'new') {
          delete subscriberToSave.id // Remove 'id' for new site subscriber
        }
        const savedSubscriber = await saveFunction(subscriberToSave)
        if (this.siteSubscriber.id === 'new') {
          router.replace(`/site-subscribers/${savedSubscriber.data.id}`)
        }
        this.siteSubscriber = savedSubscriber.data
        this.isSavedSuccessfully = true
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isSaving = false
      }
    },
    handleError(error) {
      this.errors.push(error)
    },
  },
})
